import React, { Fragment, Component } from 'react';
import NavBar from "../common/forms/NavbarCopy";
import { Loader } from "../common/forms/Loading/Loader";
import { AddNotification } from "../Methods/Notificaition.jsx";
import { getUserPassword, updateUserPassword } from "../../services/ChangePassword";
import MainPass from "../../images/boat/forgotpass.svg";
import { Form } from "informed";
import { validateProperty } from "../Validation/JoiValidation";
import { Row, Col } from "reactstrap";
import { Input } from "../common/forms/Input";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { getLocalStorageValues } from "../../services/boat";
import "../../styles/ChangePassword.scss";



class ChangePassword extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            variant: "",
            message: "",
            UserOldPassword: "",
            showPassword: false,
            oldPassword: false,
            ConfirmPassword: false,
            openNotification: false,
            oldUser: false
        }
    }

    componentDidMount = async () => {
        await this.getUserOldPassword()
    }

    getUserOldPassword = async () => {
        let data = {
            "UserType": "Public",
            "UserId": await getLocalStorageValues("UserId"),
        }

        const res = await getUserPassword(data);
        
        if (res.data.StatusCode === 1) {
            let UserOldPassword = res.data.Response[0].Password
            this.setState({ UserOldPassword: UserOldPassword })
        }
    }

    setFormApi = (formApi) => {
        this.formApi = formApi;
    };

    handlePasswordVisibility = async () => {
        this.setState({ showPassword: !this.state.showPassword })
    }


    UserName = async () => {
        const { UserName } = this.formApi.getValues()
        if (UserName && UserName.length >= 10) {
            this.setState({ oldUser: !this.state.oldUser })
        }
    }


    ConfirmPassword = async () => {
        const { UserOldPassword } = this.state
        const { OldPassword } = this.formApi.getValues();
     

        if (UserOldPassword === OldPassword) {
            this.setState({
                variant: "success",
                openNotification: true,
                message: "Confirmed password successfully",
            })
            this.setState({ ConfirmPassword: !this.state.ConfirmPassword })
        } else {
            this.setState({
                variant: "error",
                openNotification: true,
                message: "Password does not match",
            })
        }
    }

    onSubmitHandler = async () => {

        const { UserName, NewPassword } = this.formApi.getValues()
        let regData = {
            QueryType: "PPwd",
            MobileNo: UserName,
            Password: NewPassword,
        };
        
        let res = await updateUserPassword(regData);
       
        if (res.data.StatusCode == 1) {
            this.setState({
                variant: "success",
                openNotification: true,
                message: "Password updated Successfully",
            })
            this.CancelData();
        } else {
            this.setState({
                variant: "error",
                openNotification: true,
                message: res.data.Response,
            })
        }
    }


    CancelData = async () => {
        this.setState({
            OldPassword: false, ConfirmPassword: false,
            oldUser: false
        })
    }

    render() {


        const { loading, openNotification, showPassword, oldPassword, oldUser, ConfirmPassword } = this.state;

        return (

            <Fragment>
                <Loader fullPage loading={loading} />
                <AddNotification
                    visible={openNotification}
                    variant={this.state.variant}
                    message={this.state.message}
                    onClose={() => this.setState({ openNotification: false })}
                />
                <NavBar {...this.props} />
                <Form getApi={this.setFormApi} onSubmit={this.onSubmitHandler}>
                    {({ formApi, formState }) => (
                        <div className="Change-Password">
                            <div className="Change-Password-Card">




                                <div className="title-img-space">
                                    <div className="img-space">
                                        <img src={MainPass} width="250" />
                                    </div>
                                    <div className="title-space">
                                        <div>Change password?</div>
                                    </div>


                                </div>

                                <div className="form-space">





                                    <Input field="UserName" label="Mobile No" faClass="fa fa-user"
                                        onChange={() => this.UserName()}
                                        validateOnBlur validate={(e) => validateProperty(true, "name", e, "User Name")} />


                                    {oldUser && !ConfirmPassword &&

                                        <>
                                            <Input field="OldPassword"
                                                type={showPassword ? "text" : "password"} faClass="fa fa-key" label="Old Password"
                                                // onChange={() => this.OldPassword()}
                                                validateOnBlur validate={(e) => validateProperty(true, "name", e, "Password")} append={!showPassword ?
                                                    <AiFillEye className="c-pointer" onClick={this.handlePasswordVisibility} /> :
                                                    <AiFillEyeInvisible className="c-pointer" onClick={this.handlePasswordVisibility} />} />


                                            <div className="d-flex align-items-center justify-content-center mt-4">

                                                <button type="button" style={{ backgroundColor: "#0268ba" }} onClick={() => this.ConfirmPassword()} className="btn btn btn-primary mr-2 " value="Submit">
                                                    Confirm
                                                </button>
                                                <button

                                                    style={{ backgroundColor: "#dc143c" }}
                                                    type="button"
                                                    onClick={() => {
                                                        this.CancelData();
                                                    }}
                                                    className="btn btn btn-danger "
                                                    value="Submit"
                                                >
                                                    Cancel
                                                </button>
                                            </div>

                                        </>


                                    }


                                    {ConfirmPassword &&

                                        <>
                                            <Input field="NewPassword"
                                                type={showPassword ? "text" : "password"} faClass="fa fa-key" label="New Password"
                                                // onChange={() => this.OldPassword()}
                                                validateOnBlur validate={(e) => validateProperty(true, "name", e, "Password")} append={!showPassword ?
                                                    <AiFillEye className="c-pointer" onClick={this.handlePasswordVisibility} /> :
                                                    <AiFillEyeInvisible className="c-pointer" onClick={this.handlePasswordVisibility} />} />


                                            <div className="d-flex align-items-center justify-content-center mt-4">

                                                <button type="submit" style={{ backgroundColor: "#0268ba" }} className="btn btn btn-primary mr-2 " value="Submit">
                                                    Submit
                                                </button>
                                                <button

                                                    style={{ backgroundColor: "#dc143c" }}
                                                    type="button"
                                                    onClick={() => {
                                                        this.CancelData();
                                                    }}
                                                    className="btn btn btn-danger "
                                                    value="Submit"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </>

                                    }

                                    <div className="form-space-title">
                                        {!ConfirmPassword ? "Enter the mobile number associated with your account" :
                                            "Enter the new password and submit"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Form>
            </Fragment>

        )
    }
}


export default ChangePassword;